import { render, staticRenderFns } from "./responsable-sg.vue?vue&type=template&id=49fd4e27&scoped=true&"
import script from "./responsable-sg.vue?vue&type=script&lang=js&"
export * from "./responsable-sg.vue?vue&type=script&lang=js&"
import style0 from "./responsable-sg.vue?vue&type=style&index=0&id=49fd4e27&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fd4e27",
  null
  
)

export default component.exports